module.exports = "/cyber/_next/static/images/regionSteam-cb90d900d9304c7a3fdff746b6804c80.jpg";